import { useClerk } from '@clerk/clerk-react';
import { ShieldOff } from 'lucide-react';
import { DoorlyLogo } from './DoorlyLogo';
import { db } from '../db/schema';

interface Props {
  reason?: 'not_provisioned' | 'no_token';
}

export function NotProvisioned({ reason = 'not_provisioned' }: Props) {
  const { signOut } = useClerk();

  async function handleSignOut() {
    try { await db.wipe(); } catch { /* */ }
    await signOut({ redirectUrl: '/' }).catch(() => {
      localStorage.clear();
      window.location.replace('/');
    });
  }

  return (
    <div className="min-h-dvh grid place-items-center bg-bg p-4">
      <div className="max-w-sm w-full text-center space-y-5">
        <DoorlyLogo variant="icon" size={48} className="mx-auto" />
        <div className="mx-auto h-14 w-14 rounded-full bg-danger/10 grid place-items-center text-danger">
          <ShieldOff className="h-7 w-7" />
        </div>
        <div>
          <h1 className="text-title font-extrabold text-ink">
            {reason === 'no_token' ? 'Session expirée' : 'Accès non autorisé'}
          </h1>
          <p className="text-body text-ink-mute mt-2 leading-relaxed">
            {reason === 'no_token'
              ? 'Impossible d\'obtenir un jeton d\'authentification. Cela arrive souvent en navigation privée ou si les cookies tiers sont bloqués. Déconnectez-vous et réessayez en navigation normale.'
              : 'Votre compte n\'a pas été invité sur Doorly. Seuls les utilisateurs invités par un administrateur peuvent accéder à l\'application.'}
          </p>
          {reason === 'not_provisioned' && (
            <p className="text-body text-ink-mute mt-2">
              Si vous pensez qu'il s'agit d'une erreur, contactez votre responsable.
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={() => void handleSignOut()}
          className="w-full py-3 rounded-[var(--radius-sm)] bg-ink text-white text-body font-bold"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
}
